import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { RuleService } from '../../../services/rule.service';
import { RuleStatistics } from '../../../models/rule-statistics.model';

@Component({
  selector: 'app-failed-rules-card',
  templateUrl: './failed-rules-card.component.html',
  styleUrls: ['./failed-rules-card.component.scss'],
  standalone: false,
})
export class FailedRulesCardComponent implements OnChanges, OnDestroy {
  @Input() filterPayload: any;

  failCount: number = 0;
  workingCount: number = 0;
  staleCount: number = 0;
  loading = false;
  private destroy$ = new Subject<void>();

  constructor(
    private ruleService: RuleService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterPayload']) {
      this.loadRuleStats();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadRuleStats(): void {
    if (!this.filterPayload) return;

    this.loading = true;

    this.ruleService
      .GetRuleStats(this.filterPayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (stats: RuleStatistics) => {
          this.failCount = stats.failCount ?? 0;
          this.workingCount = stats.workingCount ?? 0;
          this.staleCount = stats.staleCount ?? 0;
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: (error) => {
          console.error('Error loading rule statistics:', error);
          this.loading = false;
          this.cdr.markForCheck();
        },
      });
  }
}
